import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { sideBarItems } from 'utils/appDefinitions';
import SK_utils from './SK_utils/SK_utils';

const IoContainer = () => {
  // Set page title
  React.useEffect(() => {
    document.title = `Orbital${process.env.REACT_APP_STAGE === 'production' ? '' : '-dev'} - ${sideBarItems.find((item) => item.name === 'Io').displayName}`;
  }, []);

  return (
    <div className="io">
      <Switch>
        <Route exact path="/Io/SK_Utility" component={SK_utils} />
      </Switch>
    </div>
  );
};

export default IoContainer;
